var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 86,
    viewBox: "0 0 75 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2656 66.827L32.1572 61.3795L34.7862 61.8097L33.3519 70.5731L16.8198 67.8673L17.3625 64.5514L31.2656 66.827Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8204 49.0139C39.2459 50.1577 38.4787 51.0615 37.5187 51.7253C36.5444 52.3818 35.4597 52.7412 34.2646 52.8035C33.0767 52.8515 31.8751 52.5703 30.6598 51.9599C29.4444 51.3496 28.5049 50.5465 27.8412 49.5507C27.1847 48.5406 26.8396 47.4452 26.806 46.2645C26.758 45.0766 27.0212 43.9108 27.5957 42.7669C28.1702 41.6231 28.9481 40.7157 29.9296 40.0448C30.8968 39.3668 31.9779 38.9966 33.173 38.9344C34.3753 38.8578 35.5841 39.1247 36.7994 39.7351C38.0147 40.3454 38.9471 41.1628 39.5964 42.1872C40.2529 43.1973 40.6015 44.3034 40.6423 45.5056C40.676 46.6863 40.402 47.8557 39.8204 49.0139ZM37.2038 47.6998C37.4767 47.1564 37.6029 46.5842 37.5825 45.9831C37.555 45.3606 37.3486 44.7735 36.9631 44.2218C36.5777 43.6702 36.0061 43.204 35.2483 42.8234C34.1188 42.2562 33.1029 42.122 32.2008 42.4209C31.2916 42.6984 30.6216 43.266 30.1907 44.1239C29.7599 44.9818 29.7046 45.8582 30.025 46.7532C30.3383 47.6267 31.0597 48.3472 32.1893 48.9144C33.3188 49.4817 34.331 49.6409 35.2259 49.3921C36.1137 49.1218 36.773 48.5577 37.2038 47.6998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1075 13.9018L58.0816 26.4002L55.382 28.8179L47.3798 23.5162L51.7706 32.0522L49.0531 34.486L37.2685 27.1913L39.8073 24.9177L48.3162 30.8932L43.4544 21.6513L46.1004 19.2816L54.7006 25.1432L49.7118 16.0473L52.1075 13.9018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.34eca5edb5e346dc1cd8f9ac9cb491b2.svg";
export { ForwardRef as ReactComponent };